module.exports = __webpack_public_path__ + "img/20-SMS_1.0d016a32.jpg";